import { render, staticRenderFns } from "./arbitrage-transaction-inquiry.vue?vue&type=template&id=7b0889cc&scoped=true&"
import script from "./arbitrage-transaction-inquiry.vue?vue&type=script&lang=js&"
export * from "./arbitrage-transaction-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./arbitrage-transaction-inquiry.vue?vue&type=style&index=0&id=7b0889cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0889cc",
  null
  
)

export default component.exports